import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { theme } from '../theme';
import { useResponsive } from '../hooks/useResponsive';
import DevLoginModal from './DevLoginModal';

const GoogleLogin: React.FC<{ compact?: boolean }> = ({ compact = false }) => {
  const { loginWithGoogle } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showDevModal, setShowDevModal] = useState(false);
  const isDevelopment = process.env.NODE_ENV === 'development';
  const { isMobile } = useResponsive();

  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      await loginWithGoogle();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error during Google login:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      textAlign: 'center',
      padding: isMobile ? '0' : theme.spacing.lg,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      {!compact && <>
        <h2 style={{
          margin: isMobile ? '0 0 14px 0' : '0 0 24px 0',
          color: theme.colors.text,
          fontFamily: theme.fonts.heading,
          fontSize: isMobile ? '1.3rem' : theme.fonts.sizeTitle,
          letterSpacing: theme.fonts.letterSpacingWide,
          textTransform: 'uppercase'
        }}>
          Iniciar Sesión
        </h2>

        <p style={{
          margin: isMobile ? '0 0 18px 0' : '0 0 32px 0',
          color: '#E0E0E0',
          fontFamily: theme.fonts.body,
          fontSize: isMobile ? '0.98rem' : theme.fonts.sizeBody,
          lineHeight: 1.5,
          textAlign: 'center',
          width: '100%'
        }}>
          Unite a la comunidad de Futbolero y comienza a organizar partidos increíbles
        </p>
      </>}

      <button
        onClick={handleGoogleLogin}
        disabled={loading}
        className="google-btn"
        style={{
          marginBottom: isMobile ? '14px' : 0,
          width: '100%',
          maxWidth: isMobile ? '280px' : '300px'
        }}
      >
        {loading ? (
          <>
            <span>🔄</span>
            Conectando...
          </>
        ) : (
          <>
            <span style={{ fontSize: '20px' }}>🔍</span>
            Continuar con Google
          </>
        )}
      </button>

      {isDevelopment && !compact && (
        <div style={{
          marginTop: isMobile ? '10px' : theme.spacing.md,
          width: '100%',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <button
            onClick={() => setShowDevModal(true)}
            className="dev-btn"
            style={{
              width: '100%',
              maxWidth: isMobile ? '280px' : '300px'
            }}
          >
            <span>🧪</span>
            Modo Desarrollo - Login Rápido
          </button>
        </div>
      )}

      {/* Dev Login Modal */}
      <DevLoginModal
        isOpen={showDevModal}
        onClose={() => setShowDevModal(false)}
      />
    </div>
  );
};

export default GoogleLogin; 